angular.module('accessWebClient')
    .directive('accSvgDefinition', function () {
        var definitionsToPrepend = [];

        return {
            replace: true,
            transclude: true,
            link: function ($scope, element, attrs, ctrl, transclude) {
                var svgElement = angular.element("svg#definitions");
                if (svgElement.length) {
                    definitionsToPrepend = svgElement.find("defs").get(0).childNodes;
                }

                transclude(function (inner) {
                    var definitionsToAppend = [];
                    inner.each(function (_, item) {
                        if (item instanceof Element) {
                            definitionsToAppend.push(item.outerHTML);
                        }
                    });

                    svgElement.remove();
                    document.body.insertAdjacentHTML('afterbegin', '<svg id="definitions" height="0" width="0"><defs>' + definitionsToAppend.join('') + '</defs></svg>');
                    var defsElement = angular.element('svg#definitions defs').get(0);
                    var firstDefsElement = defsElement.childNodes[0];

                    for (var index = 0; index < definitionsToPrepend.length; index++) {
                        defsElement.insertBefore(definitionsToPrepend[index], firstDefsElement);
                    }
                });
            }
        }
    })
